import React from "react";
import { png_svg, jpg_svg, doc_svg, pdf_svg, txt_svg, xls_svg } from "../../../assets/images/Images";

/**
 * Get MIME type from file name based on extension
 */
export const getFileTypeFromName = (fileName: string): string => {
  const extension = fileName.split('.').pop()?.toLowerCase() || '';
  const typeMap: Record<string, string> = {
    'pdf': 'application/pdf',
    'png': 'image/png',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'txt': 'text/plain',
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  };
  return typeMap[extension] || 'application/octet-stream';
};

/**
 * Get file type label (PDF, PNG, JPG, etc.) from file type string
 */
export const getFileTypeLabel = (fileType: string): string => {
  const lowerFileType = fileType.toLowerCase();
  
  if (lowerFileType.includes("pdf")) return "PDF";
  if (lowerFileType.includes("png")) return "PNG";
  if (lowerFileType.includes("jpg") || lowerFileType.includes("jpeg")) return "JPG";
  if (lowerFileType.includes("txt")) return "TXT";
  if (lowerFileType.includes("xls") || lowerFileType.includes("xlsx")) return "XLS";
  if (lowerFileType.includes("doc") || lowerFileType.includes("docx")) return "DOC";
  return "DOC";
};

/**
 * Get file icon component based on file type
 */
export const getFileIcon = (fileType: string, className: string = "w-6 h-6"): React.ReactElement => {
  const lowerFileType = fileType.toLowerCase();
  
  if (lowerFileType.includes("pdf")) {
    return <img src={pdf_svg} alt="PDF" className={className}/>;
  }
  if (lowerFileType.includes("png") || lowerFileType.includes("image/png")) {
    return <img src={png_svg} alt="PNG" className={className} />;
  }
  if (lowerFileType.includes("jpg") || lowerFileType.includes("jpeg") || lowerFileType.includes("image/jpeg") || lowerFileType.includes("image/jpg")) {
    return <img src={jpg_svg} alt="JPG" className={className} />;
  }
  if (lowerFileType.includes("txt") || lowerFileType.includes("text/plain")) {
    return <img src={txt_svg} alt="TXT" className={className} />;
  }
  if (lowerFileType.includes("xls") || lowerFileType.includes("xlsx") || lowerFileType.includes("application/vnd.ms-excel") || lowerFileType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
    return <img src={xls_svg} alt="XLS" className={className} />;
  }
  if (lowerFileType.includes("doc") || lowerFileType.includes("docx") || lowerFileType.includes("application/msword") || lowerFileType.includes("application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
    return <img src={doc_svg} alt="DOC" className={className} />;
  }
  // Default document icon (fallback to doc_svg)
  return <img src={doc_svg} alt="Document" className={className} />;
};

